// extracted by mini-css-extract-plugin
module.exports = {"group":"TableBody_group__pkMBN"};